import React, { useState } from 'react';
import { usePxToVw } from '../../../hooks/usePxToVw';
const SplashText = ({ text, settings }) => {
  const { pxToVw } = usePxToVw();
  const [isHovered, setIsHovered] = useState(false);

  const angleInRadians = (settings?.shadow?.angle * Math.PI) / 180;
  const offsetX = Math.cos(angleInRadians) * settings?.shadow?.distance;
  const offsetY = Math.sin(angleInRadians) * settings?.shadow?.distance;

  const style = {
    // Dimensions and layout
    height: pxToVw(settings?.height), // Button height
    width: settings?.width + '%', // Button width
    textAlign: settings?.textAlign, // Text alignment

    // Font and colors
    color: isHovered ? settings?.highlight?.fontColor : settings?.fontColor, // Font color
    fontFamily: settings?.font, // Font family
    fontSize: pxToVw(settings?.fontSize), // Font size

    // Text shadow
    textShadow: `${offsetX}px ${offsetY}px ${settings?.shadow?.size}px rgba(
      ${parseInt(settings?.shadow?.color.slice(1, 3), 16)}, 
      ${parseInt(settings?.shadow?.color.slice(3, 5), 16)}, 
      ${parseInt(settings?.shadow?.color.slice(5, 7), 16)}, 
      ${settings?.shadow?.alpha}
    )`, // Dynamic shadow for text

    // WebkitTextStroke: `${settings?.outlineThickness || 1}px ${settings?.outlineColor || '#000'}`,

    // Transition
    transition: '0.2s ease-in-out', // Smooth animation

    // Cursor style
    cursor: 'pointer',
  };

  return (
    <h3
      style={style}
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {text}
    </h3>
  );
};

export default SplashText;
